import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Departamentos", icon: "fas fa-clipboard-list", color: "#64748b", bg: "#f8fafc", href: "/Departamentos", desc: "Áreas y departamentos", perm: "menu_departamentos" },
  { label: "Navieras", icon: "fas fa-ship", color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoNavieras", desc: "Catálogo de navieras", perm: "menu_departamentos" },
];

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-clipboard-list" color="#64748b" bg="#f8fafc" title="Catálogos" subtitle="Datos de configuración del sistema" />
        {user.menu_admin ? (
          <div className="row">
            {ITEMS.map((r, i) => <MenuCard key={i} {...r} enabled={!!user[r.perm]} />)}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCatalogos;
